import React from 'react'
import styled from 'styled-components'
import { getDay } from "../lib/helpers";

const Header = styled.h1`
  margin: 0 !important;
  padding: 0;
  font-family: Montserrat;
  font-size: 25px;
  font-weight: bold;
  color: #000000;
`

const DataSubHeader = styled.div`
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`

const MetadataContainer = styled.div`
  margin-bottom: 20px;
  padding-left: 10px;
`

const ContactInfo = styled.div`
  margin-top: 50px;
`

const Confirmation = (props) => {
  const {
    handleBackClick,
    formData,
    option,
    program,
    event,
    // dayIndex,
    day,
    handleSubmit,
    isSubmitting
  } = props

  return (
    <section className="section animated fadeInUp">
      <div className="columns is-centered">
        <div className="column is-5 is-desktop">
          <div>
            <MetadataContainer>
              <Header>I am interested in</Header>
              <DataSubHeader className="has-text-grey-light">{option.label}</DataSubHeader>
            </MetadataContainer>
            <MetadataContainer>
              <Header>for</Header>
              <DataSubHeader className="has-text-grey-light">{program.name}</DataSubHeader>
            </MetadataContainer>
            <MetadataContainer>
              <Header>on</Header>
              <DataSubHeader className="has-text-grey-light">
                {getDay(day)}, {event.time} <br/>
                {program.name}
              </DataSubHeader>
            </MetadataContainer>
          </div>
          <ContactInfo>
            <h1 className="title is-3">
              Primary Contact
            </h1>
            <MetadataContainer>
              <Header>Full Name</Header>
              <DataSubHeader className="has-text-grey-light">
                {formData.name}
              </DataSubHeader>
            </MetadataContainer>
            <MetadataContainer>
              <Header>Email</Header>
              <DataSubHeader className="has-text-grey-light">
                {formData.email}
              </DataSubHeader>
            </MetadataContainer>
            <MetadataContainer>
              <Header>Phone Number</Header>
              <DataSubHeader className="has-text-grey-light">
                {formData.phone}
              </DataSubHeader>
            </MetadataContainer>
          </ContactInfo>

          {formData.children.length !== 0 &&
            <ContactInfo>
              <h1 className="title is-3" style={{marginBottom: 10}}>
                Participants
              </h1>
              {formData.children.map((child, i) => {
                return (
                  <MetadataContainer key={i}>
                    <div className="has-text-grey-light" style={{fontFamily: 'Montserrat'}}>
                      {child.name}, {child.age}
                    </div>
                  </MetadataContainer>
                )
              })}
            </ContactInfo>
          }

          <div className="field is-grouped" style={{marginTop: 10}}>
            <p className="control">
              <a className={`button is-primary is-medium ${isSubmitting && 'is-loading'}`} onClick={() => handleSubmit()}>
                Submit
              </a>
            </p>
            <p className="control">
              <a className="button is-outline is-medium" onClick={() => handleBackClick()}>
                Back
              </a>
            </p>
          </div>

        </div>
      </div>
    </section>
  )
}

export default Confirmation


// WEBPACK FOOTER //
// ./src/views/Confirmation.js